module.exports = __webpack_public_path__ + "img/ilija.78cad8f5.jpg";